import { TrayIcon, CubeIcon, RectangleDashedIcon, DresserIcon, ToolboxIcon } from "@phosphor-icons/react";
import { useContext } from "react";
import { LanguageContext } from "../globals/LanguageContext";

export const useCrateType = (value?: string) => {
    const {dictionary} = useContext(LanguageContext);

    const CrateTypes = [
    {
      icon: <TrayIcon size={32} />,
      text: dictionary.pages.materials.crates.crateTypes.cratesmallblue,
      value: "11"
    },
    {
      icon: <TrayIcon size={32} />,
      text: dictionary.pages.materials.crates.crateTypes.cratesmallyellow,
      value: "12"
    },
    {
      icon: <TrayIcon size={32} />,
      text: dictionary.pages.materials.crates.crateTypes.cratesmallgreen,
      value: "13"
    },
    {
      icon: <TrayIcon size={32} />,
      text: dictionary.pages.materials.crates.crateTypes.cratesmallred,
      value: "14"
    },
    {
      icon: <CubeIcon size={32} />,
      text: dictionary.pages.materials.crates.crateTypes.cratebigclosed,
      value: "21"
    },
    {
      icon: <RectangleDashedIcon size={32} />,
      text: dictionary.pages.materials.crates.crateTypes.cratebigopen,
      value: "22"
    },
    {
      icon: <DresserIcon size={32} />,
      text: dictionary.pages.materials.crates.crateTypes.shelf,
      value: "31"
    },
    {
      icon: <ToolboxIcon size={32} />,
      text: dictionary.pages.materials.crates.crateTypes.toolbox,
      value: "41"
    },
  ];

  
    if (value) {
    const filteredCrates = CrateTypes.filter((x=> x.value === value))
    return {filteredCrates}
    }
  return {CrateTypes};
}